var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ 'is-fixed': _vm.isOpenSelectCity }},[_c('app-menu'),_c('cities-list'),_c('app-header',{attrs:{"fixed":_vm.isFixed}}),_c('div',{staticClass:"default-wrapper",staticStyle:{"min-height":"50vh"}},[_vm._t("default")],2),_c('app-footer'),_c('burger-menu')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }